import createCache from '@emotion/cache';

// Create a custom emotion cache with specific configuration to prevent theme conflicts
const emotionCache = createCache({
  key: 'mui-license-portal',
  prepend: true,
  // Use a specific container to isolate the cache
  container: typeof document !== 'undefined' ? document.head : undefined,
  // Prevent style conflicts
  speedy: false
});

export default emotionCache;
